<template>
  <v-app>
    <v-navigation-drawer v-model="drawer" mini-variant temporary absolute>
      <v-list-item class="px-2">
        <v-list-item-avatar>
          <v-img src="./assets/logo.mk7.opaque.png"></v-img>
        </v-list-item-avatar>
        <v-list-item-title>John Leider</v-list-item-title>
        <v-btn icon @click.stop="mini = !mini">
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>
      </v-list-item>
      <v-divider></v-divider>
      <v-list dense>
        <v-list-item v-for="item in items" :key="item.text" link :href="item.url">
          <v-list-item-icon :style="{
    'align-items':'center!important'
  }">
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ item.text }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    <v-content>
      <router-view v-on:drawer='(drawer=!drawer)' v-if="(browser.name == 'Chrome' && browser.version >= 61)" :hash="blockly_hash"></router-view>
      <v-layout v-else fill-height align-center wrap text-xs-center>
        <v-layout row wrap>
          <v-flex xs12 font-weight-black display-1>
            {{browser.name}} (version {{browser.version}}) is not supported by this website.
          </v-flex>
          <v-flex xs12 font-weight-black display-1>
            Please install Google Chrome (version 61 or higher).
          </v-flex>
          <v-flex xs12 font-weight-black>
            <v-btn fab text large @click="goBack()">
              <v-icon>fas fa-arrow-left</v-icon>
            </v-btn>
            <v-btn fab text large @click="goURL('http://makerspace.ecu.edu.au/')">
              <v-icon>fas fa-home</v-icon>
            </v-btn>
            <v-btn fab text large href="https://www.google.com/chrome/">
              <img src='./assets/chrome-logo.svg'>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-layout>
    </v-content>

  </v-app>
</template>

<script>
import UAParser from 'ua-parser-js'

export default {
  name: 'App',
  data () {
    return {
      blockly_hash: "",
      items: [
        { icon: 'home', text: 'Home', url: 'http://makerspace.ecu.edu.au/' },
        { icon: 'code', text: 'Code', url: 'http://makerspace.ecu.edu.au/code' }
      ],
      drawer: false,
      browser: {
        name: "",
        version: 0
      }
    }
  },
  methods: {
    goURL(url) {
      window.location.assign(url);
    },
    goBack() {
      window.history.back();
    }
  },
  mounted() {
    let parser = new UAParser();
    let ua = parser.getResult();
    this.browser.name = ua.browser.name;
    this.browser.version = ua.browser.major;
    if (this.browser.name == 'Chrome' || this.browser.version < 61) this.drawer = true;
    let hash = this.$route.path.match(/.*\/(.*)/);
    this.blockly_hash = hash[1];
  }
}
</script>

<style>
html, body {
  overflow: hidden;
  max-width: 100vw;
  max-height: 100vh;
}

::-webkit-scrollbar {
    width: 8px;
}
::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 4px rgba(0,0,0,0.3);
}
::-webkit-scrollbar-thumb {
  background-color: #E6DB74;
  outline: 1px solid #E6DB74;
}
</style>